/*
 * Model for User login and the user Model
 */

define([
  "backbone",
  "jquery",
  "underscore",
  "configuration/properties",
  "messaging/messenger",
  "modules/admin/userAdmin/notifications/notificationModel",
], function (Backbone, $, _, Properties, Messenger, NotificationModel) {
  const LoginModel = {};

  LoginModel.authModel = Backbone.Model.extend({
    defaults: {
      csrfToken: "",
    },
    url: function () {
      return Properties.adminRootURL + "/auth";
    },
  });

  LoginModel.loginModel = Backbone.Model.extend({
    defaults: {
      loginName: "",
      password: "",
      error: false,
    },
    url: function () {
      return Properties.rootURL + "/user";
    },
  });

  LoginModel.userModel = Backbone.Model.extend({
    idAttribute: "loginName",
    defaults: {
      userName: "",
    },
    notifications: function () {
      this.notificationsCol = this.getSubModel(
        this.notificationsCol,
        NotificationModel.collection,
        "/notifications",
        false,
      );
      return this.notificationsCol;
    },
    //toggle the quick create UI as the home page.  The second parameter is a boolean (true if quick create should be the home page).
    toggleQuickCreateAsHomePage: function (kbId, quickCreateShouldBeHomePage) {
      kbId = parseInt(kbId, 10);
      var kbDefaults = _.findWhere(this.get("kbDefaults"), { id: kbId });
      var canCreateTopic = Messenger.reqres.request("can:create:topic", kbId);
      if (!canCreateTopic) {
        kbDefaults.value["showQuickCreate"] = false;
      } else {
        kbDefaults.value["showQuickCreate"] = quickCreateShouldBeHomePage;
      }
      this.trigger("change");
    },
    url: function () {
      return Properties.rootURL + "/user";
    },
    validateAttribute: function (attribute, value) {
      if (attribute === "userName") {
        return (
          this.validateRequiredValue(value, { maxLength: 255 }) ||
          this.validateSafeCharacters(value)
        );
      }
    },
    saveChildren: function (options) {
      this.saveSubModels(options);
    },
  });

  LoginModel.oauthModel = Backbone.Model.extend({
    defaults: {
      client_id: Properties.oauthClientId,
    },
    url: function () {
      return Properties.adminRootURL + "/oauth/token";
    },
  });

  LoginModel.revokeOauthModel = Backbone.Model.extend({
    defaults: {
      client_id: Properties.oauthClientId,
    },
    url: function () {
      return Properties.adminRootURL + "/oauth/revoke";
    },
  });

  return LoginModel;
});
